import React, { useState, useEffect } from "react";
import './Nav.css';
import Logo from '../Home/img/Non Rect Color crpped.png';
import Logo_dark from '../Home/img/white.png';
import { Squash as Hamburger } from 'hamburger-react';

export default function Nav(props) {
  const [isOpen, setOpen] = useState(false);
  const [isScrolled, setScrolled] = useState(false);
  const { darkMode } = props;

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setOpen(!isOpen);
  };

  // Function to handle smooth scrolling to a section
  const scrollToSection = (sectionId) => {
    if (sectionId === "top") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      const section = document.getElementById(sectionId);
      if (section) {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.clientHeight;
        const windowHeight = window.innerHeight;
        const scrollTo = sectionTop - (windowHeight - sectionHeight) / 2;
        window.scrollTo({ top: scrollTo, behavior: "smooth" });
      }
    }
    setOpen(false); // Close the mobile menu after clicking a link
  };

  return (
    <nav  className={`navbar navbar-expand-lg ${darkMode ?'custom-navbar-dark' : 'custom-navbar'}  fixed-top ${isScrolled ? 'nav-scrolled' : '' }`} id="navbar">
      <div className="container navnav">

        {darkMode ?
        <a className="navbar-brand" href="#">
          <img src={Logo_dark} width={200} alt="Logo" />
        </a>
        :
        <a className="navbar-brand" href="#">
        <img src={Logo} width={200} alt="Logo" />
      </a>
        }
        <button
          className="navbar-toggler"
          style={{ border: "none" }}
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
          onClick={toggleMenu}
        >
          <Hamburger
            toggled={isOpen}
            toggle={toggleMenu}
          />
        </button>
        <div
          className={`collapse navbar-collapse justify-content-end ${isOpen ? "show" : ""}`}
          id="navbarNav"
        >
          <ul className="navbar-nav">
            <li className="nav-item">
              <a
                className="nav-link"
                href="#top"
                onClick={() => scrollToSection("top")}
              >
                Home
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="#company"
                onClick={() => scrollToSection("company")}
              >
                Company
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="#service"
                onClick={() => scrollToSection("service")}
              >
                Developers
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link contact1"
                href="#contact"
               
                onClick={() => scrollToSection("contact")}
              >
                Contact
                <i class="fa-solid fa-envelope" style={{marginLeft:10}}></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
